// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotographyContract_root__10OBY","lastUpdated":"PhotographyContract_lastUpdated__2GXyp"};